// extracted by mini-css-extract-plugin
module.exports = {"group":"login_form_group-module--group--2wJLR"};